import Icon from "components/icon";
import styled from "@emotion/styled";

export const StyledLock = styled(Icon)`
  top: 0.76rem;
  position: absolute;
  display: block;
  right: 0.94rem;
`;
